import React from "react";

export const Brand = ({ className = "" }) => (
  <span className={`font-serif tracking-tight ${className}`} data-testid="wat-brand">
    WAT
    <span className="text-ink-soft mx-[0.05em]">&gt;</span>
    WAT
    <sup className="font-mono text-[0.5em] align-super ml-[0.05em]">2</sup>
  </span>
);

export default Brand;
